<div class="d-flex align-items-center color-picker-combo">
	<div class="color-picker-box">
		<input aria-label="Color Picker" type="color" [(ngModel)]="value" (ngModelChange)="emitChange()"
			[placeholder]="placeholder" [disabled]="disabled" #colorPicker data-cy="openColorPicker" />
	</div>
	<input aria-label="Color Picker Value" type="text" [(ngModel)]="value" (ngModelChange)="emitChange()"
		[placeholder]="placeholder" #input [disabled]="disabled" class="color-picker-input form-control ms-2"
		data-cy="editColorPicker" />
</div>